import type { Thought } from "@/entities/thoughts/model/types"

export function isPendingApproval(thought: Thought): boolean {
	return thought.is_ai_generated && !thought.is_read
}
